import { DoctorCountry } from './doctor-country.model';
import { MailAttention } from './mail-attention.model';
import { Province } from './province.model';
import { Town } from './doctor-town.model';

export class DoctorCorrespondence {
    id: number;
    mailAttentionId?: number;
    name: string;
    surname1: string;
    surname2: string;
    number: string;
    door: string;
    nameOfVia: string;
    typeOfVia: string;
    postalCode: string;
    townId: number;
    provinceId: number;
    countryId: number;
    doctorId?: number;
    country: DoctorCountry;
    mailAttention?: MailAttention;
    province: Province;
    town: Town;

    constructor() {
        this.country = new DoctorCountry();
        this.mailAttention = new MailAttention();
        this.province = new Province();
        this.town = new Town();
    }

}
